import React, { useState } from 'react';
import { RolloverConstants } from '../../../RolloverConstants';
import { SSJBeaconButton } from '../../../../Shared/Beacon/Registry';
import Check from '../../../../../assets/images/Check.svg';
import { useSelector } from 'react-redux';
import retirementIcon from '../../../../../assets/images/retirement-icon.svg';
import printIcon from '../../../../../assets/images/print-icon.svg';
import TRP from '../../../../Shared/TRP/TRP';
import { callApi, getEndpoint } from '../../../../../utils/api';
import { useEffect } from 'react';
import config from '../../../../../config/config';

export function Direct() {
  const fundingTrackingData = useSelector(
    (state) => state?.fundingTrackingData
  );
  const [userName, setUserName] = useState('');
  const getUserDetails = () => {
    callApi(getEndpoint('personalInformation'))
      .then((response) => {
        setUserName(response?.body?.fullName);
      })
      .catch((e) => {
        console.log('failed', e);
      });
  };
  useEffect(() => {
    getUserDetails();
  }, []);
  return (
    <div id="direct-rollover-guide-container" className="rollover-guide">
      <div className="page-header">
        <div className="title">
          {RolloverConstants.rolloverGuidePage.direct.title}
          <div className="nextStep-wrapper_header_print">
            <SSJBeaconButton
              data-testid="beacon-button"
              id="printButton"
              label="Print"
              variant="tertiary"
              icon-align="left"
              onClick={() => {
                window.print();
              }}
            >
              <img
                slot="icon"
                icon-align="left"
                alt="Print Button"
                fill="none"
                className="nextStep-wrapper_header_print_icon"
                height="18"
                width="18"
                src={printIcon}
              />
            </SSJBeaconButton>
          </div>
        </div>
        <div className="description">
          {RolloverConstants.rolloverGuidePage.direct.description.replace(
            'Institution name',
            fundingTrackingData?.payload?.onboardingDataStore
              ?.onboardingDatastoreRollover?.externalFinancialInstituteName
          )}
        </div>
      </div>
      <div className="page-body">
        <div className="instruction">
          <div className="number-icon">
            <div className="circle">1</div>
          </div>
          <div className="details details-direct ">
            <div className="title">
              {RolloverConstants.rolloverGuidePage.direct.sectionOne.title.replace(
                'Institution name',
                fundingTrackingData?.payload?.onboardingDataStore
                  ?.onboardingDatastoreRollover?.externalFinancialInstituteName
              )}
            </div>
            <div className="mobile-number">
              {fundingTrackingData?.store?.institutionPhone}
            </div>

            <div className="instruction direct-distribution">
              <div className="number-icon">
                <div className="check-mark">
                  <img alt="edit-icon" src={Check} />
                </div>
              </div>
              <div className="details">
                Verify your identity with your financial institution.
              </div>
            </div>

            <div className="instruction direct-distribution">
              <div className="number-icon">
                <div className="check-mark">
                  <img alt="edit-icon" src={Check} />
                </div>
              </div>
              <div className="details">
                Ask if your employer retirement plan requires a "Letter of
                Acceptance" from T. Rowe Price to release a rollover check.
              </div>
            </div>
          </div>
        </div>
        <div className="line-thin" />
        <div className="instruction mail-check">
          <div className="number-icon">
            <div className="circle">2</div>
          </div>
          <div className="details details-direct">
            <div className="title">Request a rollover check made out to:</div>
            <div className="sub-description">
              <div className="section-2">
                <p>
                  <TRP /> Trust Company
                </p>
                <p className="blocked_data">{`FBO ${userName}`}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="line-thin" />
        <div className="instruction mail-check">
          <div className="number-icon">
            <div className="circle">3</div>
          </div>
          <div className="details details-direct">
            <div className="title">
              Ask that the check and any documents be mailed to:
            </div>
            <div className="sub-description">
              <div className="section-1">
                <p>
                  <TRP /> Account Services
                </p>
                <p>PO Box 17300</p>
                <p>Baltimore, MD 21297-1300</p>
              </div>
              <div className="section-2">
                <label className="sub-title">For Overnight:</label>
                <p>
                  <TRP /> Account Services
                </p>
                <p>Mail Code 17300</p>
                <p>4515 Painters Mill Rd.</p>
                <p>Owings Mills, MD 21117-4903</p>
              </div>
            </div>
          </div>
        </div>
        <div className="line-thin" />
        <div className="instruction whats-next">
          <div className="retirement-icon">
            <img src={retirementIcon} alt="retirement-icon" />
          </div>
          <div className="details">
            <div className="title"> What's next?</div>

            <div className="sub-description">
              {RolloverConstants.rolloverGuidePage.whatsNext.replace(
                '<institution name>',
                fundingTrackingData?.payload?.onboardingDataStore
                  ?.onboardingDatastoreRollover?.externalFinancialInstituteName
              )}
            </div>
          </div>
        </div>

        <div className="line-thin" />
        <SSJBeaconButton
          data-testid="beacon-button-window-location"
          id="detials-submit-btn"
          className="submit-btn"
          label="Go to My Account Dashboard   >"
          variant="secondary"
          onClick={() =>
            (window.location.href = `${config.url}/${RolloverConstants.rolloverFunding.link.accountDashboardDev}`)
          }
        />
      </div>
      <div className="line-thin" />
    </div>
  );
}
